import React from "react";

function SubstrateHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-8 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Substrate Development Services
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    At Xeer, we utilize the versatile Rust-based Substrate
                    framework to build high-performance blockchain solutions
                    tailored to your needs. Our expert team crafts robust,
                    future-proof applications, enabling you to enter the market
                    swiftly and efficiently.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SubstrateHero;
